@if (isApplicationLoading$ | async) {
  <div>
    <lh-screen-loader text="Loading, please wait. . ." />
  </div>
} @else {
  <lh-layout lhScreenSizeTracker />
  <p-confirmDialog [closable]="false" [baseZIndex]="1010" />
  <p-toast [life]="3000" [baseZIndex]="TOAST_Z_INDEX" />
}
